import searchRoutes from './routes'

/* @ngInject */
const dispatchRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(searchRoutes.index.path, {
      url: searchRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'searchCtrl',
      redirectTo: searchRoutes.home.path,
    })
    .state(searchRoutes.home.path, {
      url: searchRoutes.home.url,
      template: require('./templates/home.html'),
    })
}

export default dispatchRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/search/search.routes.js